//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-facets-cta',
  components: {},
  props: {
    facets: {
      type: Array,
      required: true,
    },
    totalProducts: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isHover: false,
    }
  },
  computed: {
    icon() {
      return this.isHover ? 'options-light' : 'options'
    },
  },
}
